// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"8b12a724","124":"32646e41","306":"05d76808","395":"0a547972","481":"3bd91c01","665":"efd4cd71","728":"9cba2ef0","776":"db072681","789":"4dd3a69a","856":"66036264","910":"a3489fe9"}[chunkId] + ".chunk.js";
};